function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import { config } from "../config";
import { RegionURLMapper } from "./api-routes-mapper-region";
var apiProxyUrl = config.apiProxyUrl;
var scheme = "https?://";
var domain = "(serverless|runtime).vonage.[^/]+";
var getPublicPatterns = function() {
    var _obj;
    return _obj = {}, _define_property(_obj, "^".concat(scheme, "deployment-api.([^.]+).*").concat(domain, "/(.*)"), "deployment/$3"), _define_property(_obj, "^".concat(scheme, "marketplace-api.([^.]+).*").concat(domain, "/(.*)"), "marketplace/$3"), _define_property(_obj, "^".concat(scheme, "vonage-assets.([^.]+).*").concat(domain, "/(.*)"), "assets/$3"), _define_property(_obj, "^".concat(scheme, "graphql(?:.newenv)?.([^.]+).*").concat(domain, "/v1/graphql"), "$2/graphql"), _define_property(_obj, "^".concat(scheme, "vcr-subscriptions-service.([^.]+).*").concat(domain, "/(.*)"), "subscriptions/$3"), _obj;
};
var getPrivatePatterns = function() {
    var domain = "(nexmo|vonage).[^/]+";
    var _obj;
    var legacyPatterns = (_obj = {}, _define_property(_obj, "^".concat(scheme, "api-([^.]+).*").concat(domain, "/(.*)/deployment/(.*)"), "deployment/$4"), _define_property(_obj, "^".concat(scheme, "api-([^.]+).*").concat(domain, "/(.*)/marketplace/(.*)"), "marketplace/$4"), _define_property(_obj, "^".concat(scheme, "api-([^.]+).*").concat(domain, "/(.*)/assets/(.*)"), "assets/$4"), _define_property(_obj, "^".concat(scheme, "api-([^.]+).*").concat(domain, "/(.*)/graphql/(.*)"), "serverless/graphql"), _obj);
    var _obj1;
    var regionalPatterns = (_obj1 = {}, _define_property(_obj1, "^".concat(scheme, "api-([^.]+).*").concat(domain, "/v1/vcr/([^/]+)/api/deployment/(.*)"), "deployment/$4"), _define_property(_obj1, "^".concat(scheme, "api-([^.]+).*").concat(domain, "/v1/vcr/([^/]+)/api/marketplace/(.*)"), "marketplace/$4"), _define_property(_obj1, "^".concat(scheme, "api-([^.]+).*").concat(domain, "/v1/vcr/([^/]+)/api/assets/(.*)"), "assets/$4"), _define_property(_obj1, "^".concat(scheme, "api-([^.]+).*").concat(domain, "/v1/vcr/([^/]+)/api/graphql/(.*)"), "serverless/graphql"), _obj1);
    return _object_spread({}, regionalPatterns, legacyPatterns);
};
export var mapAdminApiRoute = function(url) {
    var internalPattern = new RegExp("^".concat(scheme, "graphql-internal."));
    if (new RegExp("".concat(internalPattern.source, "(?:[^.]+.)?qa.")).exec(config.graphqlApiInternalUrl)) {
        return config.graphqlApiInternalUrl;
    }
    if (internalPattern.test(url)) return url;
    try {
        var parsed = new URL(url);
        var hostParts = parsed.hostname.split(".");
        var region = null;
        if (hostParts[0] === "graphql") {
            // graphql.apse1.runtime.vonage.cloud or graphql.qa.runtime.vonage.cloud
            region = hostParts[1]; // could be apse1, qa, euc1-1, etc.
        } else if (hostParts[0].startsWith("api-")) {
            // Try to extract cluster code from new URL format path
            var clusterMatch = /^\/v1\/vcr\/([^/]+)\/api\//.exec(parsed.pathname);
            if (clusterMatch) {
                region = clusterMatch[1]; // euw1, use1, apse1, apse2
            } else {
                // Fallback: infer region from hostname geo code
                region = hostParts[0].replace("api-", "");
            }
        }
        switch(region){
            case "eu":
                region = "euw1";
                break;
            case "us":
                region = "use1";
                break;
            case "ap":
                region = "apse1";
                break;
        }
        if (!region) {
            throw new Error("Could not determine region from URL: ".concat(url));
        }
        return config.graphqlApiInternalUrl.replace(RegExp("(?<=graphql-internal\\.)[^.]+(?=\\.runtime\\.vonage\\.cloud)"), region);
    } catch (e) {
        throw new Error("Invalid URL: ".concat(url));
    }
};
var resolveProxyUrl = function(mappedRoute) {
    // Extract cluster from URL format (/v1/vcr/{cluster}/api/)
    var clusterRegex = /\/v1\/vcr\/([^/]+)\/api\//;
    var clusterMatch = clusterRegex.exec(mappedRoute);
    if (clusterMatch) {
        return apiProxyUrl.replace("$1", clusterMatch[1]);
    }
    // Extract region from hostname (api-{geo})
    var regionRegex = /api-([^.]+)\./;
    var regionMatch = regionRegex.exec(mappedRoute);
    if (regionMatch) {
        var mappedRegion = regionMatch[1] === "ap" ? "apac" : regionMatch[1];
        return apiProxyUrl.replace("$1", mappedRegion || "");
    }
    return apiProxyUrl;
};
export var mapApiRoute = function(_route) {
    var route = RegionURLMapper.mapUrl(_route);
    if (!apiProxyUrl || !route) {
        return _route;
    }
    {
        var regex = new RegExp("^".concat(scheme, "(cs-[^.]+).([^.]+).*").concat(domain, "$"));
        // First check CodeServer pattern (workspace launch URL) since it's pattern
        // is different
        if (regex.test(route)) {
            var result = route.replace(regex, function(_, group1, group2) {
                var mappedRegion = group2 === "ap" ? "apac" : group2; // Map "ap" to "apac"
                var proxyUrl = apiProxyUrl.replace("$1", mappedRegion || "");
                return [
                    proxyUrl,
                    "cs/".concat(group1, "/")
                ].join("/");
            });
            return "".concat(result, "?folder=/home/coder/project");
        }
    }
    var patterns = _object_spread({}, getPublicPatterns(), getPrivatePatterns());
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = Object.entries(patterns)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _step_value = _sliced_to_array(_step.value, 2), pattern = _step_value[0], replacement = _step_value[1];
            var regex1 = new RegExp(pattern);
            if (regex1.test(route)) {
                var finalApiProxyUrl = resolveProxyUrl(route);
                return route.replace(regex1, [
                    finalApiProxyUrl,
                    replacement
                ].join("/"));
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return route;
};

//# sourceMappingURL=api-routes-mapper.js.map